const overflowWrap = "\n  word-wrap: break-word; // Deprecated name for overflow-wrap\n  overflow-wrap: break-word;\n";

export { overflowWrap };
